import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioDetailResponseDTO,
	type ClientRelatedListResponseDTO,
	deletePortfolioIdRelatedRelatedIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useUnpinPortfolioRelatedMutation = (id: number) => {
	const queryClient = useQueryClient();
	const detailKey = PortfolioKeys.portfolioDetail(id);

	return useMutation<
		ClientRelatedListResponseDTO,
		Error,
		number,
		{ previousDetail: ClientPortfolioDetailResponseDTO | undefined }
	>({
		mutationFn: processResponse((relatedId: number) =>
			deletePortfolioIdRelatedRelatedIdV2(id, relatedId),
		),
		onMutate: async (relatedId: number) => {
			await queryClient.cancelQueries({ queryKey: detailKey });

			const previousDetail =
				queryClient.getQueryData<ClientPortfolioDetailResponseDTO>(detailKey);

			if (previousDetail) {
				queryClient.setQueryData<ClientPortfolioDetailResponseDTO>(detailKey, {
					...previousDetail,
					related: previousDetail.related.filter(
						(item) => item.id !== relatedId,
					),
				});
			}

			return { previousDetail };
		},
		onError: (_error, _relatedId, context) => {
			if (context?.previousDetail) {
				queryClient.setQueryData(detailKey, context.previousDetail);
			}
		},
		onSettled: () => {
			queryClient.invalidateQueries({ queryKey: PortfolioKeys.all });
		},
	});
};
